import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { MapPin, Clock } from 'lucide-react';
export function ContactCTA() {
  return <section id="contact" className="py-24 relative overflow-hidden bg-rotterdam-black" data-id="element-38">
      {/* Full-width background for Desktop ONLY */}
      <img src="https://cdn.magicpatterns.com/uploads/vhF5iuQKE9t7HTNfWJGNNw/banner_definitivo_4.png" alt="" className="absolute inset-0 w-full h-full object-cover opacity-60 hidden md:block" data-id="element-39" />
      <div className="absolute inset-0 bg-rotterdam-black/50 hidden md:block" data-id="element-40" />

      <div className="max-w-4xl mx-auto text-center relative z-10 px-6" data-id="element-41">
        <motion.h2 initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} className="text-4xl md:text-6xl font-serif font-bold mb-8" data-id="element-42">
          Tu turno te espera
        </motion.h2>
      </div>

      {/* Full-width background image section for Address & Hours */}
      <div className="w-full relative py-16 mt-4 mb-12" data-id="element-43">
        {/* Background for Mobile ONLY */}
        <img src="https://cdn.magicpatterns.com/uploads/vhF5iuQKE9t7HTNfWJGNNw/banner_definitivo_4.png" alt="Rotterdam Barbería" className="absolute inset-0 w-full h-full object-cover opacity-60 md:hidden" data-id="element-44" />
        <div className="absolute inset-0 bg-rotterdam-black/50 md:hidden" data-id="element-45" />

        <div className="max-w-4xl mx-auto relative z-10 px-6" data-id="element-46">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="flex flex-col md:flex-row justify-center items-center gap-8 text-rotterdam-cream/90" data-id="element-47">
            <div className="flex flex-col items-center gap-3" data-id="element-48">
              <MapPin className="w-6 h-6 text-rotterdam-gold pearl-icon" data-id="element-49" />
              <span className="text-center font-medium text-lg" data-id="element-50">
                Av. Ovidio Lagos 1035
                <br data-id="element-51" />
                Rosario, Santa Fe
              </span>
            </div>
            <div className="hidden md:block w-px h-20 bg-rotterdam-gold/30" data-id="element-52" />
            <div className="flex flex-col items-center gap-3" data-id="element-53">
              <Clock className="w-6 h-6 text-rotterdam-gold pearl-icon" data-id="element-54" />
              <span className="text-center font-medium text-lg" data-id="element-55">
                Lun-Vie: 10:00 – 19:30
                <br data-id="element-56" />
                Sáb: 10:00 – 14:00
                <br data-id="element-57" />
                Dom: Cerrado
              </span>
            </div>
          </motion.div>
        </div>
      </div>

      <div className="max-w-4xl mx-auto text-center relative z-10 px-6" data-id="element-58">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} className="flex flex-col sm:flex-row justify-center items-center gap-4" data-id="element-59">
          <motion.a href="https://es.wikipedia.org/wiki/Toro_de_lidia" target="_blank" rel="noopener noreferrer" className="inline-block px-10 py-5 bg-[#00E5FF] text-rotterdam-black font-bold text-lg uppercase tracking-wide rounded-full shadow-[0_0_20px_rgba(0,229,255,0.6)] hover:shadow-[0_0_35px_rgba(0,255,213,0.8)] transition-all duration-300 animate-pulse" data-id="element-60">
            Reserva hoy
          </motion.a>
        </motion.div>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.6
      }} className="mt-16 text-rotterdam-gray font-serif italic text-xl" data-id="element-61">
          Un corte. Una experiencia. Un lugar que no vas a querer cambiar.
        </motion.p>
      </div>
    </section>;
}